/* ============================================================
   tio-relacionados.js

   El objeto `recommendations` de Liquid solo se llena cuando la section
   se pide a la Product Recommendations API. Este archivo hace esa unica
   peticion y reemplaza el contenedor por el HTML ya renderizado por el
   servidor: el markup sigue teniendo UNA sola fuente de verdad, el
   propio Liquid. Aca no se arma ninguna card a mano.

   Si la peticion falla, el bloque queda vacio y la PDP sigue entera:
   los relacionados son ayuda, no parte del camino de compra.
   ============================================================ */
(function () {
  'use strict';

  function montar(cont) {
    var url = cont.getAttribute('data-url');
    var id = cont.getAttribute('data-product-id');
    var limite = cont.getAttribute('data-limite') || '3';
    var seccion = cont.getAttribute('data-section-id');
    if (!url || !id || cont.hasAttribute('data-listo')) return;
    cont.setAttribute('data-listo', '1');

    fetch(url + '?section_id=' + seccion + '&product_id=' + id + '&limit=' + limite)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('[data-tio-relacionados]');
        if (nuevo && nuevo.querySelector('.te-product-card')) {
          cont.innerHTML = nuevo.innerHTML;
        }
      })
      .catch(function (err) {
        console.warn('[tio-relacionados]', err);
      });
  }

  function iniciar() {
    var conts = document.querySelectorAll('[data-tio-relacionados]');
    for (var i = 0; i < conts.length; i++) montar(conts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
